import { Chip, Stack } from '@locus-taxy/disco-ui';
import type { StatusChipColor } from '../../utils/enumPresentation';

interface EntityStatusChipsProps {
  status?: string;
  subStatus?: string;
  /** Configured colour for the status value; absent keeps the neutral filled chip. */
  statusColor?: StatusChipColor;
  subStatusColor?: StatusChipColor;
}

/** A configured colour draws the same light-tint chip the grid uses for that value. */
function chipColorProps(color: StatusChipColor | undefined) {
  return color
    ? { variant: 'subtle' as const, color }
    : { variant: 'filled' as const };
}

export default function EntityStatusChips({
  status,
  subStatus,
  statusColor,
  subStatusColor,
}: Readonly<EntityStatusChipsProps>) {
  if (!status && !subStatus) {
    return null;
  }

  if (status && subStatus) {
    return (
      <Stack
        direction="row"
        gap={0}
        align="center"
        className="overflow-hidden rounded-full"
      >
        <Chip
          label={status}
          {...chipColorProps(statusColor)}
          size="sm"
          className="rounded-r-none"
        />
        <Chip
          label={subStatus}
          {...chipColorProps(subStatusColor)}
          size="sm"
          className="rounded-l-none"
        />
      </Stack>
    );
  }

  return status ? (
    <Chip label={status} {...chipColorProps(statusColor)} size="sm" />
  ) : (
    <Chip label={subStatus} {...chipColorProps(subStatusColor)} size="sm" />
  );
}
